import React, { createContext, useContext, useState, useCallback, useRef } from 'react';
import { AlertTriangle } from 'lucide-react';

const ConfirmContext = createContext(null);

export const ConfirmProvider = ({ children }) => {
  const [dialog, setDialog] = useState(null);
  const resolver = useRef(null);

  const confirm = useCallback((message, opts = {}) => {
    return new Promise(resolve => {
      resolver.current = resolve;
      setDialog({ message, title: opts.title || 'Are you sure?', confirmText: opts.confirmText || 'Confirm', danger: opts.danger !== false });
    });
  }, []);

  const close = (result) => {
    setDialog(null);
    if (resolver.current) { resolver.current(result); resolver.current = null; }
  };

  return (
    <ConfirmContext.Provider value={{ confirm }}>
      {children}
      {dialog && (
        <div onClick={() => close(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', backdropFilter: 'blur(3px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000 }}>
          <div onClick={e => e.stopPropagation()} className="card" style={{ width: 360, padding: 24 }}>
            <div style={{ display: 'flex', gap: 10, marginBottom: 14 }}>
              <AlertTriangle size={20} color={dialog.danger ? 'var(--red)' : 'var(--amber)'} style={{ flexShrink: 0, marginTop: 1 }} />
              <div style={{ fontWeight: 800, fontSize: 16, color: 'var(--text)' }}>{dialog.title}</div>
            </div>
            <p style={{ fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.6, marginBottom: 22 }}>{dialog.message}</p>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button onClick={() => close(false)} className="btn-ghost">Cancel</button>
              <button onClick={() => close(true)} style={{
                background: dialog.danger ? 'var(--red)' : 'var(--pink)', color: '#fff', border: 'none',
                borderRadius: 'var(--r-md)', padding: '9px 18px', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'var(--font)',
              }}>{dialog.confirmText}</button>
            </div>
          </div>
        </div>
      )}
    </ConfirmContext.Provider>
  );
};

export const useConfirm = () => useContext(ConfirmContext).confirm;
